import {useRoleStore} from '../store/roleStore';
import {
  CreateRoleRequest,
  RoleFilters,
  Role
} from '../models/role.model';
import {useCallback} from 'react';

export const useRoles = () => {
  const {
    // State
    roles,
    currentRole,
    pagination,
    loading,
    creating,
    updating,
    deleting,
    error,
    createError,
    updateError,
    deleteError,
    filters,

    // Actions
    fetchRoles,
    getRoleById,
    createRole,
    deleteRole,
    setFilters,
    clearError,
    clearCreateError,
    clearDeleteError,
    reset
  } = useRoleStore();

  // Enhanced actions with error handling
  const handleFetchRoles = useCallback(async (newFilters?: RoleFilters) => {
    try {
      await fetchRoles(newFilters);
    } catch (error) {
      throw error;
    }
  }, [fetchRoles]);

  const handleCreateRole = useCallback(async (roleData: CreateRoleRequest): Promise<Role> => {
    try {
      const newRole = await createRole(roleData);
      return newRole;
    } catch (error) {
      throw error;
    }
  }, [createRole]);


  const handleDeleteRole = useCallback(async (roleId: number): Promise<void> => {
    try {
      await deleteRole(roleId);
    } catch (error) {
      throw error;
    }
  }, [deleteRole]);

  const handleGetRoleById = useCallback(async (id: number): Promise<Role | null> => {
    try {
      return await getRoleById(id);
    } catch (error) {
      throw error;
    }
  }, [getRoleById]);

  return {
    // State
    roles,
    currentRole,
    pagination,
    loading,
    creating,
    updating,
    deleting,
    error,
    createError,
    updateError,
    deleteError,
    filters,

    // Enhanced actions
    fetchRoles: handleFetchRoles,
    createRole: handleCreateRole,
    deleteRole: handleDeleteRole,
    getRoleById: handleGetRoleById,
    setFilters,

    // Error management
    clearError,
    clearCreateError,
    clearDeleteError,
    reset
  };
};
